import { http } from '@/utils/http'
import { BASE_URL } from '@/utils/host'

const api40002 = '/api/40002'
const api10020 = '/api/10020'
const api50800 = '/api/50800'

// 账号密码操作
export function login(data) {
  return http.post(`${BASE_URL.WG + api10020}/sso/v2/login`, data)
}
// export function login(data) {
//   return http.post(`${BASE_URL.WG + api10020}/sso/login`, data)
// }
// 用户信息
export function getLoginUser(data) {
  return http.post(`${BASE_URL.WG + api40002}/rms/user/getLoginUser`, data)
}

// 退出登录
export function logout() {
  return http.post(BASE_URL.WG + '/api/10020/sso/logout')
}
// 修改头像
export function update_avatar(data) {
  return http.post(BASE_URL.WG + '/api/40002/rms/user/update_avatar', data)
}
// 验证旧密码
export function check_password(data) {
  return http.post(BASE_URL.WG + '/api/40002/rms/user/check_password', data)
}
// 修改密码
export function update_personal_pass(data) {
  return http.post(BASE_URL.WG + '/api/40002/rms/user/update_personal_pass', data)
}
// 初始密码
export function userCreatePwd(data) {
  return http.post(BASE_URL.WG + '/api/40002/web/user/createPwd', data)
}
// 登录用户是否已设置密码
export function userExistsPwd(data) {
  return http.post(BASE_URL.WG + '/api/40002/web/user/existsPwd', data)
}
// 获取登录次数
export function get_login_num(data) {
  return http.post(BASE_URL.WG + '/api/40002/rms/user/get_login_num', data)
}
// 修改个人资料
export function updatePersonal(data) {
  return http.post(BASE_URL.WG + '/api/40002/rms/user/update_personal', data)
}
// 获取用户所有菜单数据
export function getMenuList(data) {
  return http.post(BASE_URL.WG + '/api/40002/rms/menu/getMenuByUserId', data)
}
// 获取用户公邮配置
export function getEmailSettingWithUserId() {
  return http.post(BASE_URL.WG + '/api/40002/user/publicmail/getEmailSettingWithUserId')
}

// 根据id获取公邮配置信息
export function getEmailSettingWithConfigId(data) {
  return http.post(BASE_URL.WG + '/api/40002/branch/tenant/getEmailSettingByConfigId', data)
}

// 创建用户公邮配置
export function createEmailSetting(data) {
  return http.post(BASE_URL.WG + '/api/40002/user/publicmail/createEmailSetting', data)
}

// 更新公邮配置
export function updateEmailSetting(data) {
  return http.post(BASE_URL.WG + '/api/40002/branch/tenant/updateEmailSetting', data)
}

// 修改公邮状态
export function updateEmailStatus(data) {
  return http.post(BASE_URL.WG + '/api/40002/user/publicmail/updateStatus', data)
}

// 验证滑块并获取手机验证码
export function getPhoneCode(data) {
  return http.post(BASE_URL.WG + '/api/10020/sso/checkCode', data)
}

// 验证手机号是否存在
export function existPhone(data) {
  return http.post(BASE_URL.WG + '/api/40002/rms/user/exist_phone', data)
}

// 修改手机号
export function updateCellPhone(data) {
  return http.post(BASE_URL.WG + '/api/40002/rms/user/update_cellphone', data)
}
// 校验手机验证码
export function checkPhoneCode(data) {
  return http.post(BASE_URL.WG + '/api/10020/register/checkPhoneCode', data)
}

// 获取判断是否改过密码的信息
export function getUserInfoFlag(data) {
  return http.post(`${BASE_URL.WG + api50800}/prime/user/getByUsernameNew`, data)
}
